/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import CallActions from './call-actions';
import { Typography, Grid } from '@mui/material';
import { CallBox, CallHeader, CallDetails, CallStateActive, CallButton } from './call-styles';
import { Phone } from '@mui/icons-material';
import { formatUSPhoneNumber } from '../../utils/formatter';
import { useLwp } from '../../hooks/use-lwp';

export default function CallInProgress(props: {}) {
  const {
    phoneState: { phoneNumber, contactName }
  } = useLwp();
  const { hangupCall } = useLwp();

  return (
    <CallBox data-testid="call-inprogress">
      <CallHeader>
        <Grid container>
          <Grid item xs={10} zeroMinWidth>
            <CallStateActive>CALL IN PROGRESS</CallStateActive>
            <Typography variant="h6" noWrap>
              {contactName ? contactName : ''}
            </Typography>
            <Typography variant="body2">{formatUSPhoneNumber(phoneNumber)}</Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: 'right' }}>
            <CallButton
              onClick={hangupCall}
              sx={{ backgroundColor: 'rgb(244, 73, 72)', '&:hover': { backgroundColor: 'rgb(244, 73, 72)' } }}
            >
              <Phone
                sx={{
                  transform: 'rotate(135deg)'
                }}
              />
            </CallButton>
          </Grid>
        </Grid>
      </CallHeader>
      <CallDetails>
        <CallActions {...props} />
      </CallDetails>
    </CallBox>
  );
}
